export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            了解黑料吃瓜在线的故事与使命
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-1">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4">
                让每一次吃瓜都有料
              </h3>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  黑料吃瓜在线诞生于 2023 年，由一群热爱追踪娱乐八卦的资深"吃瓜群众"创立。我们深感在信息碎片化的时代，想要实时掌握全网八卦动态是一件费时费力的事情——需要在微博、豆瓣、知乎、贴吧等多个平台之间来回切换，还经常错过关键信息。
                </p>
                <p>
                  因此，我们打造了这个一站式八卦聚合平台。通过自研的多源信息监控系统，实时抓取和整理来自 30+ 主流平台的热点内容，以清晰的时间线和分类体系呈现给用户，让吃瓜变得更加高效和愉快。
                </p>
                <p>
                  我们坚持零门槛浏览的初心——不设付费墙、不搞会员制、不限制阅读数量。同时也坚守内容底线，标注信息来源，拒绝纯造谣内容，在娱乐与责任之间找到平衡。未来，我们将继续扩展信息覆盖范围，优化浏览体验，为千万吃瓜群众提供更好的服务。
                </p>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-64 space-y-4">
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="font-heading text-3xl font-bold text-primary-500 mb-1">2023</div>
                <div className="text-xs text-foreground-500">平台创立</div>
              </div>
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="font-heading text-3xl font-bold text-accent-500 mb-1">30+</div>
                <div className="text-xs text-foreground-500">信息源覆盖</div>
              </div>
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="font-heading text-3xl font-bold text-secondary-500 mb-1">50K+</div>
                <div className="text-xs text-foreground-500">累计爆料收录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}